var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00001A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.919.297 28.284 28.284-2.122 2.122L.797 2.419z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.797 28.581 29.081.297l2.122 2.122L2.919 30.703z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuClose);
export default __webpack_public_path__ + "static/media/icon-menu-close.ca20d86e8364ad748c947025ef771994.svg";
export { ForwardRef as ReactComponent };